var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElastic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6 16c0-2.648-2.152-4.8-4.8-4.8H.736A15.853 15.853 0 000 16c0 1.672.256 3.288.736 4.8H20.8c2.648 0 4.8-2.152 4.8-4.8z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32c5.216 0 9.848-2.504 12.76-6.376A9.54 9.54 0 0022.4 23.2H1.728C4.36 28.416 9.76 32 16 32z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.752 0 4.36 3.584 1.728 8.8H22.4c2.44 0 4.664-.92 6.36-2.416C25.84 2.512 21.216 0 16 0z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.656 8.8a17.556 17.556 0 00-5.4-6.8 16.114 16.114 0 00-6.544 6.8h11.944z",
    fill: "#F9A825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.264 30a17.704 17.704 0 005.4-6.8H1.712A16.085 16.085 0 008.264 30z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.744 11.2A15.895 15.895 0 000 16c0 1.672.264 3.28.744 4.8h13.784c.432-1.528.672-3.136.672-4.8 0-1.664-.24-3.272-.672-4.8H.744z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_155"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28.76v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElastic);
export default __webpack_public_path__ + "static/media/elastic.15e05ac5fad462dffe60c83e19d78f31.svg";
export { ForwardRef as ReactComponent };